import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormBuilder,
  FormControl,} from '@angular/forms';
@Component({
  selector: 'app-add-discount',
  templateUrl: './add-discount.component.html',
  styleUrls: ['./add-discount.component.scss'],
})


export class AddDiscountComponent implements OnInit {
  discount:any={};
  title = 'Add';
  submitted= false;
  discount_detail:any;
  current_value = 'discount_info'
  constructor(public formBuilder:FormBuilder) { }

  ngOnInit() {
    let d = {};
    this.form_data.map((res)=>{
      res.group_fields.map((val)=>{
        d[val.name] = new FormControl(val.value , [])
      })
    })
    this.discount = this.formBuilder.group(d);
  }


  edit_discount(form: NgForm){

  }

  insert_discount(form: NgForm){
    this.submitted = true;
    // console.log(this.discount)
    if (form.valid) { 

    }
  }

  editoption(attr,index,type,method, modalType){
    // let me = this;
    // let modal = await this.modalCtrl.create({
    //   component: RetrieveOrderPage,
    //   cssClass: 'hold-modal',
    //   componentProps: {
    //     is_modal: 1,
    //     //   show_walk_in: 1
    //   }
    // });
    // await modal.present();
    // let { data } = await modal.onWillDismiss();
  
  //   if(data){
  //     // if (this.show) {
  //       if (type == 'Add') { 
  //         this.discount.products = data.products
  //         if(!this.discount.discount_requirements)
  //           this.discount.discount_requirements = [];
  //         if (modalType == 'requirement') {
  //           this.discount.discount_requirements.push(data.item)
  //         }
  //       } else {
  //         this.discount.products = data.products;
  //         if (modalType == 'requirement') {
  //           this.discount.discount_requirements[index] = data.item;
  //         }
  //       }
  //       if (modalType == 'product') {
  //         this.discount.products = data.products;
  //       } else if (modalType == 'category') {
  //         this.discount.categories  = data.categories;
  //       }
  //       // console.log(this.discount)
  //     }
  // });
}

form_data:any=[
  {
    group_title :'Discount Info',
    mapped_by :'discount_info',
    group_fields : [
       {
        label:'Discount Name',
        input_type:'input',
        type:'text',
        name:'discount_name',
        placeholder : '',
        required : true,
        hidden: false,
        value : '',
        tooltip: 'Category Name'
       },
       {
        label : 'Discount type',
        input_type : 'drop-down',
        type : 'text',
        name :'discount_type',
        placeholder : 'discount_type',
        required : false,
        hidden: false,
        value : '',
        options:[
          {name: 'Assigned to Products',value : 'Assigned to Products'},
          {name: 'Assigned to Categories',value:'Assigned to Categories'},
          {name: 'Assigned to Sub Total',value: 'Assigned to Sub Total'},
          {name: 'Assigned to Delivery Charges',value: 'Assigned to Delivery Charges'}
        ],
        tooltip: '',
       },
       {
        label : 'Price or Product Discount',
        input_type : 'drop-down',
        type : 'text',
        name : 'price_or_product_discount',
        placeholder : 'price_or_product_discount',
        required : false,
        hidden : false,
        value : '',
        options:[
          {name:'Price',value:'Price'},
          {name:'Product',value:'Product'}
        ]
       },
       {
        label : 'Priority',
        input_type : 'input',
        type : 'text',
        name:'priority',
        placeholder : '',
        required : true,
        hidden: false,
        value : '',
       },
      //  title: 'Validity'
       {
        label : 'Min Quantity',
        input_type : 'input',
        type : 'text',
        name : 'min_qty',
        required : false,
        hidden : false,
        value : ''
       },
       {
        label : 'Max Quantity',
        input_type : 'input',
        type : 'text',
        name : 'max_qty',
        required : false,
        hidden : false,
        value : ''
       },
      //  title: 'Limitations'
       {
        label : 'Limitations',
        input_type : 'drop-down',
        type : 'text',
        name : 'limitations',
        placeholder : 'Limitations',
        required : false,
        hidden : false,
        value : '',
        options : [
          {name: 'Unlimited',value: 'Unlimited'},
          {name: 'N times only',value: 'N times only'},
          {name: 'N times per user',value: 'N times per user'},

        ]
       },
       {
        label : 'Limitations Count',
        input_type : 'input',
        type : 'text',
        name : 'limitations_count',
        placeholder : '',
        value : '',
        required : false,
        hidden : false
       },
       {
        label : 'Discount Amount',
        input_type : 'input',
        type : 'text',
        name : 'discount_amount',
        required : false,
        value : '',
        placeholder : ''
       },
       {
        label : 'Max Discount Amount',
        input_type : 'input',
        type : 'text',
        name : 'max_discount_amount',
        required : false,
        value : '',
        placeholder : ''
       },
       {
        label : 'Use coupon code',
        input_type : 'checkbox_',
        type : 'text',
        name :'use_coupon_code',
        placeholder : '',
        required : false,
        hidden: false,
        value : 0
       },
       {
        label : 'Coupon code',
        input_type : 'input',
        type : 'text',
        name : 'coupon_code',
        required : false,
        value : '',
        placeholder : ''
       },
    ]
  }
];




}
